export const initialState = {}


// WEBPACK FOOTER //
// ./src/interface/store/departments/entity/selectors.js